import { Component, HostListener, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { LoadingService } from 'src/app/layout/loading/loading.service';
import { Utility } from 'src/app/shared/utility/utility';
import { IAppState } from 'src/app/store/states/app.state';
import { SrcInsuranceSelService } from '../src-insurance-sel/src-insurance-sel.service';
import { map } from 'rxjs/internal/operators/map';
import { selectedMstHTOrg } from '../../../../store/selectors/mstHTOrg.selector';
import { ActivatedRoute, Router } from '@angular/router';
import { GetIMstHTOrg } from 'src/app/store/actions/mstHTOrg.action';
import { QueryParams } from 'src/app/shared/constant';
import { IMstHTOrg } from 'src/app/models/mstHTOrg.interface';

@Component({
  selector: 'app-src-insurance-sel',
  templateUrl: './src-insurance-sel.component.html',
  styleUrls: ['./src-insurance-sel.component.scss']
})
export class SrcInsuranceSelComponent implements OnInit {
  objHTOrg: IMstHTOrg;
  dataReservation: any;
  constructor(
    private insuranceSelService: SrcInsuranceSelService,
    private loadingSrv: LoadingService,
    private router: Router,
    private util: Utility,
    private store: Store<IAppState>,
    private routeActived: ActivatedRoute,
  ) {
    this.store.select(selectedMstHTOrg).pipe(map(i => i)).subscribe(item => {
      if (!this.util.isNullOrEmpty(item)) {
        this.objHTOrg = item;
      }
    });
  }

  ngOnInit(): void {
    this.util.resetZoomBrowser();
    // Check HTOrgCode by url
    history.pushState(null,"", window.location.href);
    const strKey = this.routeActived.snapshot.queryParams[QueryParams.HtOrgCode];
    if (!this.util.isNullOrEmpty(strKey)) {
      const strHTOrgCode = sessionStorage.getItem('HTOrgCode');
      if (this.util.isNullOrEmpty(strHTOrgCode) || strHTOrgCode !== strKey) {
        sessionStorage.setItem('HTOrgCode', strKey);
      }
      this.GetMstHTOrg(strKey);
      this.dataReservation = {};
      sessionStorage.removeItem('DataReservation');
    } else {
      this.router.navigateByUrl('404');
    }
  }
  @HostListener('window:popstate', ['$event'])
  onBrowserBackBtnClose(event: Event) {
    window.history.forward()
}
  GetMstHTOrg(pHTOrgCode: any) {
    this.loadingSrv.setDisplay(true);
    const objSearch = { HTOrgCode: pHTOrgCode };
    this.insuranceSelService.GetMstHTOrg(objSearch).subscribe(data => {
      if (data) {
        this.objHTOrg = data;
        this.store.dispatch(new GetIMstHTOrg(data));
      } else {
        this.router.navigateByUrl('404');
      }
      this.loadingSrv.setDisplay(false);
    }, err => {
      this.loadingSrv.setDisplay(false);
    });
  }

  OpenScreen0302() {
    if (this.dataReservation?.typeReservation === 2) {
      this.dataReservation = {};
    }
    this.dataReservation.HTOrgName = this.objHTOrg?.HTOrgName;
    this.dataReservation.typeReservation = 1;
    sessionStorage.setItem('DataReservation', JSON.stringify(this.dataReservation));
    this.router.navigateByUrl('insurance-inp');
  }

  OpenScreen0303() {
    if (this.dataReservation?.typeReservation === 1) {
      this.dataReservation = {};
    }
    this.dataReservation.HTOrgName = this.objHTOrg?.HTOrgName;
    this.dataReservation.typeReservation = 2;
    sessionStorage.setItem('DataReservation', JSON.stringify(this.dataReservation));
    this.router.navigateByUrl('personal-inf-inp');
  }
  @HostListener('window:beforeunload', ['$event']) unloadHandler(event: Event) {
    sessionStorage.removeItem('DataReservation');
  }
}
